import { papelPrincipal } from '@/components/layout/menu'
import { permissoesGestaoComercial } from '@/utils/gestaoComercial'

/**
 * Quem vê o quê no nível do consultor (AN-10 §5) — espelho do `@PreAuthorize` do backend:
 *
 * | | ADMIN | GERENTE+GESTOR | GERENTE sem / OPERADOR | CONSULTOR | ONBOARDING |
 * |---|---|---|---|---|---|
 * | catálogo, atribuir, histórico, trilha (`ADMIN_ONLY`) | ✅ | ❌ | ❌ | ❌ | ❌ |
 * | atribuições, só leitura (`GESTAO_CAMPANHA_EQUIPE`) | ✅ | só equipe | ❌ | ❌ | ❌ |
 * | o próprio nível (`/meu`) | — | — | — | ✅ | ❌ |
 *
 * O nível é SÓ INFORMATIVO (Q26): estas permissões dizem apenas onde o nível aparece; nada de
 * comissão, ranking, meta ou acesso depende dele. A tela só esconde; quem decide é o backend.
 * A persona consultor segue o `papelPrincipal` do menu: CONSULTOR + OPERADOR residual continua
 * consultor.
 */
export interface PermissoesNivelConsultor {
  ehAdmin: boolean
  ehGestorEquipe: boolean
  /** Página "Níveis" (ADMIN ou GERENTE+GESTOR_EQUIPE). */
  vePagina: boolean
  /** Catálogo, atribuição, histórico com justificativa e trilha. */
  administra: boolean
  /** Chip no dashboard e card "Meu nível" no Perfil. */
  veMeuNivel: boolean
}

export const permissoesNivelConsultor = (
  permissoes: string[] | undefined | null
): PermissoesNivelConsultor => {
  const g = permissoesGestaoComercial(permissoes)
  return {
    ehAdmin: g.ehAdmin,
    ehGestorEquipe: g.ehGestorEquipe,
    vePagina: g.ehAdmin || g.ehGestorEquipe,
    administra: g.ehAdmin,
    veMeuNivel: papelPrincipal(permissoes) === 'CONSULTOR',
  }
}

/**
 * Cor do texto sobre a cor livre do nível (R8): branco ou tinta, pelo maior contraste
 * (luminância relativa do WCAG). Apresentação apenas — a cor vem do cadastro.
 */
export const corDoTextoSobre = (hex: string): string => {
  const m = /^#?([0-9A-Fa-f]{6})$/.exec(hex.trim())
  if (!m) return '#17191D'
  const canal = (i: number) => {
    const c = parseInt(m[1].slice(i, i + 2), 16) / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  }
  const l = 0.2126 * canal(0) + 0.7152 * canal(2) + 0.0722 * canal(4)
  const contrasteBranco = 1.05 / (l + 0.05)
  const contrasteTinta = (l + 0.05) / (0.0107 + 0.05) // #17191D ≈ 0.0107
  return contrasteBranco >= contrasteTinta ? '#FFFFFF' : '#17191D'
}
